import { FETCH_PREFERENCES, LOG_OUT_USER, SET_DEFAULT_PREFERENCES, UPDATE_PREFERENCES } from "../../actions/actionTypes";


const preferencesReducer = (state={}, action) => {
    let preferences = state;
    if (action && action.payload && action.payload.preferences && !action.payload.errors){
        switch(action.type){
            case FETCH_PREFERENCES:
                return action.payload.preferences;
            case SET_DEFAULT_PREFERENCES:
                return action.payload.preferences;
            case UPDATE_PREFERENCES:
                return action.payload.preferences;
            default:
                return preferences;
        }
    }
    if (action.type === LOG_OUT_USER){
        preferences = {}
    }
    return preferences;
}

export default preferencesReducer;